export default __webpack_public_path__ + "static/media/logo.575d031f.png";